import {
  DragStart,
  DragUpdate,
  DropResult,
  ResponderProvided,
} from '@hello-pangea/dnd';
import { useTranslation } from 'react-i18next';
import {
  endAnnouncement,
  liftAnnouncement,
  updateAnnouncement,
} from '@/utils/questions/dnd/dndAnnouncements';
import { Helpers } from '@/components/question/view/primitives/shared/dnd/DragDropAnswerContext';

export function useDndA11y(getToken: Helpers['getToken']) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionView.dnd',
  });

  const labelOf = (id: string) => {
    const token = getToken(id);
    return token?.content.text ?? token?.content.altText ?? t('itemFallback');
  };

  return {
    dragHandleUsageInstructions: t('usageInstructions'),
    announceDragStart: (start: DragStart, provided: ResponderProvided) =>
      provided.announce(liftAnnouncement(t, labelOf(start.draggableId))),
    announceDragUpdate: (update: DragUpdate, provided: ResponderProvided) =>
      provided.announce(
        updateAnnouncement(t, labelOf(update.draggableId), update),
      ),
    announceDragEnd: (result: DropResult, provided: ResponderProvided) =>
      provided.announce(
        endAnnouncement(t, labelOf(result.draggableId), result),
      ),
  };
}
